import { notificationIcon2 } from "assets/icons";
import React from "react";
import SkeletonLoader from "shrimmer/SkeletonLoader";
import { createArray } from "utils/surveyHelper";

const NotificationShrimmer = () => {
  return (
    <>
      {createArray(4).map(() => {
        return (
          <li>
            <img src={notificationIcon2} alt="" />{" "}
            <p>
              <SkeletonLoader type="text" height={10} width={150} count={2.4} />
            </p>
            <small>
              <SkeletonLoader type="text" height={13} width={70} />
            </small>
          </li>
        );
      })}
    </>
  );
};

export default NotificationShrimmer;
